import React, { ElementType, InputHTMLAttributes, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { IconProps } from '../../../../icons/IconProps'
import { useWindowResize } from '../../../../utils/domUtils'
import { ModalProps } from '../types'
import { FromToRangeModalDesktop } from './FromToRangeModalDesktop'
import { FromToRangeModalMobile } from './FromToRangeModalMobile'

export interface FromToRangeModalProps extends PropsWithChildren<ModalProps> {
  title?: string
  icon?: ElementType<IconProps>
  fromValue?: string | number
  toValue?: string | number
  inputType?: InputHTMLAttributes<HTMLInputElement>['type']
  renderFooter?(props: FromToRangeModalProps): React.ReactNode[]
  onConfirm?(): void
  onFromChange?(value: string | number): void
  onToChange?(value: string | number): void
  labels?: {
    from: string
    to: string
  }
  errors?: {
    from?: boolean
    to?: boolean
  }
}

export const FromToRangeModal: React.FC<FromToRangeModalProps> = (props) => {
  const { t } = useTranslation()
  const { labels = { from: t('From'), to: t('To') } } = props

  const isMobile = useWindowResize()
  return isMobile ? (
    <FromToRangeModalMobile labels={labels} {...props} />
  ) : (
    <FromToRangeModalDesktop labels={labels} {...props} />
  )
}
